// Copy paste this template to create a new component
// that can be put into the masonry layout!

import * as React from "react";
import { css } from "emotion";
import Card from "./Card";
import { defaults, Bar, Line } from "react-chartjs-2";
import { labeledStatement } from "@babel/types";

const barChartOptions = {
  maintainAspectRatio: false,
  responsive: true,
  legend: {
    display: true,
    // align: 'start',
    // onClick: null
  },
  datasets: {
    line: {
      tension: 0,
      fill: false
    }
  },
  scales: {
    xAxes: [
      {
        display: true,
        position: "bottom",
        scaleLabel: {
          display: true,
          labelString: "Year"
        },
        ticks: {
          autoSkip: false,
          maxRotation: 45, // This will set the labels on the x-axis to a 90-degree angle
          minRotation: 45  // This will set the minimum rotation for the labels on the x-axis to a 90-degree angle
        }
      }
    ],
    yAxes: [
      {
        ticks: {
          callback: function(label) {
            if (/\s/.test(label)) {
              if (label.split(" ").length > 2) {
                label = label.split(" ");
                label[1] = label[0] + " " + label[1];
                label.shift();
                return label.map(l => l + '%');
              } else {
                return label.split(" ").map(l => l + '%');
              }
            } else {
              return label + '%';
            }
          }
        },
        stacked: false,
        display: true,
        scaleLabel: {
          display: true,
          labelString: "Percent of Intern Class"
        }
      }
    ]
  },
  title: {
    display: false,
  },
  tooltips:{
    callbacks:{
      label: function(tooltipItem){
        return this._data.datasets[tooltipItem.datasetIndex].label +': ' + tooltipItem.yLabel + '%';
      }
    }
  }
};

interface InternEthnicityProps{
  caption: Array<string>;
}

class InternEthnicityBreakdownBarChartCard extends React.Component<InternEthnicityProps> {
  constructor(props: InternEthnicityProps){
    super(props);
  }
  state = {
    //using this as the data
    //hardcoded
    labels: ["Fall 2019", "Fall 2020", "Fall 2021","Fall 2022", "Fall 2023", "Winter 2024"],
    borderWidth: 1,
    datasets: [
      { data: [1, 1.7, 2.9,.99,(0/51*100).toFixed(2),(2/43*100).toFixed(2)], borderColor: "#48A2D3", backgroundColor: "#48A2D3", label: "Black or African American"},
      { data: [31.8, 23.8, 28.8,21.78,(12/51*100).toFixed(2),(20/43*100).toFixed(2)], borderColor: "#F0A202", backgroundColor: "#F0A202", label: "White"},
      { data: [7.3, 10.4, 10.8,12.87,(4/51*100).toFixed(2),(3/43*100).toFixed(2)], borderColor: "#733B90", backgroundColor: "#733B90", label: "Hispanic or Latino"},
      { data: [0, 0, 0.7,0,(0/51*100).toFixed(2),(0/43*100).toFixed(2)], borderColor: "#EFD50D", backgroundColor: "#EFD50D", label: "Native American or American Indian"},
      { data: [44.3, 48.8, 42.4,43.56,(26/51*100).toFixed(2),(10/43*100).toFixed(2)], borderColor: "#5DBD5B", backgroundColor: "#5DBD5B", label: "Asian/Pacific Islander"},
      { data: [NaN, 5.4, 6.5,2.97,(1/51*100).toFixed(2),(3/43*100).toFixed(2)], borderColor: "#0080C6", backgroundColor: "#0080C6", label: "Middle Eastern (not recorded in 2019)"},
      { data: [11.5, 9.2, 7.2,14.85,(6/51*100).toFixed(2),(5/43*100).toFixed(2)], borderColor: "#C377E0", backgroundColor: "#C377E0", label: "Multiracial"},
      { data: [4.2, 0.8, 0.7,2.97,(2/51*100).toFixed(2),(0/43*100).toFixed(2)], borderColor: "#E84855", backgroundColor: "#E84855", label: "Prefer not to say"},
    ]
  };
  render() {
    //this.collect_data();
    defaults.global.defaultFontColor = "#0a0a0a";
    const caption = this.props.caption;
    return (
      <Card>
        <div
          className={css`
            font-size: 30px;
            text-align: center;
            margin-bottom: 5px;
            @media (max-width: 700px) {
              font-size: 18px;
            }
          `}
        >
          Interns race/ethnicity breakdown
        </div>
        <div
          className={css`
            height: 600px;
            width: 100%;
          `}
        >
          <Line
            data={this.state}
            options={{
              ...barChartOptions
            }}
          />
        </div>
        <div
          className={css`
            font-size: 15px;
            margin: 10px;
            color: black;
            text-align: left;
          `}
        >
            {caption}
        </div>
      </Card>
    );
  }
}

export default InternEthnicityBreakdownBarChartCard;
